'use client';
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const getInputAttributes = (id, hovered, dropdownOpened)=>{
    return _extends({}, hovered >= 0 && {
        'aria-activedescendant': `${id}-${hovered}`
    }, dropdownOpened && {
        'aria-controls': `${id}-items`,
        'aria-owns': `${id}-items`,
        'aria-expanded': dropdownOpened
    }, {
        'aria-autocomplete': 'list',
        'aria-haspopup': 'listbox',
        role: 'combobox'
    });
};

export { getInputAttributes };
//# sourceMappingURL=getInputAttributes.js.map
